<template>
<div class="chapter">
<div class="inner_page">
<p class="imagea" style="margin-top:0em;margin-bottom:0em"><img alt="images" src="images/map.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// maps.vue?55d09bf6